module.exports = __webpack_public_path__ + "img/checked_icon.717636a6.svg";